









































































import Vue from "vue"

export default Vue.extend({
  data() {
    return {
      entity: {} as any,
      fieldName: [] as any,
      item: [] as any
    }
  },
  props: {
    generateTree2: {},
    passedEntity: {} as any
  },
  methods: {
    convertLabel(label: string) {
      return label.replace(/([A-Z])/g, " $1").toLowerCase().replace(/^\w/, c => c.toUpperCase())
    },
    back() {
      this.entity = {}
      this.fieldName = []
      this.$emit("back")
    },
    save() {
      this.$emit("save", this.entity)
      this.entity = {}
      this.fieldName = []
    },
    openEdit() {
      this.entity = JSON.parse(JSON.stringify(this.passedEntity))
    }
  },
  created() {
    this.openEdit()
  }
})
